
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class AbonelikDevirBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "AboneDevirBasvuruSave";
    super(baseUrl);
  }


  saveAbonelikDevirBasvuruSave(request: AboneDevirBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new AbonelikDevirBasvuruAPI();

class AboneDevirBasvuruSaveRequest {
    BasvuruTuruId: number;   
    SicilKodu: number | null;  
    AboneNo: number;          
    AboneTipi: number | null;   

    constructor(
        basvuruTuruId: number,
        sicilKodu: number | null,
        aboneNo: number,
        aboneTipi: number | null
    ) {
        this.BasvuruTuruId = basvuruTuruId;
        this.SicilKodu = sicilKodu;
        this.AboneNo = aboneNo;
        this.AboneTipi = aboneTipi;
    }
}
export { AboneDevirBasvuruSaveRequest };
